import {styled as muiStyled} from '@mui/material'

const InputElement = muiStyled('input')({})

export default InputElement
